
import { PropType } from '@vue/runtime-core'
import { Button } from 'vant'

interface IHeaderState {
  onClick: () => void
}

export default {
  components: {
    [Button.name as string]: Button
  },
  props: {
    handleOpenApp: {
      type: Function as PropType<() => void>,
      required: false
    },
    picture: {
      type: String as PropType<string>,
      default: 'empty.png'
    },
    btnBackground: {
      type: String as PropType<string>
    },
    btnTextColor: {
      type: String as PropType<string>
    },
    content: {
      type: String as PropType<string>,
      default: '暂无数据，下载App体验更多功能吧'
    },
    btnText: {
      type: String as PropType<string>,
      default: '下载App'
    },
    isShowBtn: {
      type: Boolean as PropType<boolean>,
      default: true
    }
  },
  setup(
    props: Readonly<{
      handleOpenApp?: () => void
    }>
  ): IHeaderState {
    const onClick = () => {
      props.handleOpenApp && props.handleOpenApp()
    }

    return {
      onClick
    }
  }
}
